import i18n from 'app-i18n';
import { formatCurrency } from 'util/currency';
import * as yup from 'yup';

export const refundFormSchema = yup.object().shape({
  isPartialRefund: yup.boolean().default(true),
  refundAmount: yup
    .number()
    .required()
    .test('is-max-refundable', '', (value, context) => {
      // @ts-ignore
      const { options, createError } = context;
      // @ts-ignore
      const { refundableAmount, currency } = options;
      if (refundableAmount === 0) {
        return createError({
          message: i18n.t(
            'forms.fields.refundForm.amount.errors.maxRefundableAmount',
            {
              refundableAmount: formatCurrency(refundableAmount, currency),
            },
          ),
        });
      } else if (!!refundableAmount && refundableAmount / 1000 < value)
        return createError({
          message: i18n.t(
            'forms.fields.refundForm.amount.errors.maxRefundableAmount',
            {
              refundableAmount: formatCurrency(refundableAmount, currency),
            },
          ),
        });
      return true;
    })
    .test('is-max-charge-amount', '', (value, context) => {
      // @ts-ignore
      const { options, createError } = context;
      // @ts-ignore
      const { chargeAmount, currency } = options;
      if (chargeAmount / 1000 < value)
        return createError({
          message: i18n.t('forms.fields.refundForm.amount.errors.maxAmount', {
            orderTotal: formatCurrency(chargeAmount, currency),
          }),
        });
      return true;
    }),
  refundReason: yup.string().required(),
  requestedBy: yup.string().required(),
  emailReceipt: yup.boolean().default(false),
});
